import {FbFormObject} from '../class/fb_form_object';

export class RallySeriesTrack extends FbFormObject {
    /**
     * override default columns
     */
    public setColumns() {
        this.column_definition = [
            {id: 'series_id', label: 'Series', visible: true, noclick: false, disable_ripple: true},
            {id: 'track_id', label: 'Track', visible: true, noclick: false, disable_ripple: true},
            {id: 'race_type_id', label: 'Type', visible: true, noclick: false, disable_ripple: true},
            {id: 'race_start', label: 'Start', visible: true, noclick: false, disable_ripple: true},
            {id: 'race_end', label: 'End', visible: true, noclick: false, disable_ripple: true}
        ];
    }

    /**
     * override default fields
     */
    public setEditFields() {
        this.edit_fields = [
            {
                caption: 'Assign Track',
                class: 'card card-1 padding',
                field_class: '',
                fields: [
                    {
                        type: 'number',
                        name: 'series_id',
                        disabled: true,
                        rules: [
                            {rule: 'required'}
                        ]
                    },
                    {
                        type: 'select',
                        name: 'track_id',
                        options: this.select_boxes['race_track_select'],
                        disabled: false,
                        rules: [
                            {rule: 'required'}
                        ]
                    },
                    {
                        type: 'select',
                        name: 'race_type_id',
                        options: this.select_boxes['race_type_select'],
                        disabled: false,
                        rules: [
                            {rule: 'required'}
                        ]
                    },
                    {
                        type: 'datetime',
                        name: 'race_start',
                        disabled: false,
                        rules: [
                            {rule: 'required'}
                        ]
                    },
                    {
                        type: 'datetime',
                        name: 'race_end',
                        disabled: false,
                        rules: [
                            {rule: 'required'}
                        ]
                    },
                ]
            }
        ];

        super.setEditFields();
    }

    /**
     * override / load all stores we need
     */
    public loadStores(ext_obj?: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {

            this.stores['assigned_series_track'] = this.storeService.createNoneGlobalStore('assigned_series_track',
                'race/series/' + String(this.custom_obj.series_id) + '/tracks', 'assign_id');

            this.stores['race_tracks'] = this.storeService.getStore('race_tracks');
            this.stores['race_types'] = this.storeService.getStore('race_types');

            this.main_store = this.stores['assigned_series_track'];

            const selectFilter = [];
            selectFilter.push('first=0');
            selectFilter.push('no_limit=1');


            const stores = [];
            // if (!this.stores['sc_version'].isLoaded()) {
            stores.push(this.stores['assigned_series_track'].loadStore(this.filter));
            stores.push(this.stores['race_tracks'].loadStore('?' + selectFilter.join('&')));
            stores.push(this.stores['race_types'].loadStore('?' + selectFilter.join('&')));
            // }

            Promise.all(stores).then((result) => {
                resolve(true);
            });
        });
    }

    public getDefaultModel() {
        console.log('this.custom_obj', this.custom_obj);
        return {
            data: {
                series_id: this.custom_obj.series_id,
                track_id: null,
                race_type_id: null,
                race_start: null,
                race_end: null
            }
        };
    }

    /**
     * custom reload
     */
    public reload(): Promise<any> {
        return this.getStore().loadStore('');
    }

    /**
     * override select_boxes
     */
    public setSelectboxes() {
        // call super
        this.parseTrackSelectBox();
        this.parseTypeSelectBox();
        super.setSelectboxes();
    }

    public parseTrackSelectBox(): any[] {
        const options = [];
        const records = this.stores['race_tracks'].getRecords();
        for (let i = 0; i < records.length; i++) {
            const rec = records[i];
            options.push(
                {
                    name: rec.data.track_name,
                    value: rec.data.track_id
                }
            );
        }
        this.select_boxes['race_track_select'] = options;
        return this.select_boxes['race_track_select'];
    }

    public parseTypeSelectBox(): any[] {
        const options = [];
        const records = this.stores['race_types'].getRecords();
        for (let i = 0; i < records.length; i++) {
            const rec = records[i];
            options.push(
                {
                    name: rec.data.type_name,
                    value: rec.data.type_id
                }
            );
        }
        this.select_boxes['race_type_select'] = options;
        return this.select_boxes['race_type_select'];
    }

}
